import axios from 'axios';
import config from '../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../core/modules/common/tools/URLTools';

const getAdminReportData = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getAdminReportData',
    stub: config.useStubbedEndpoints,
  });
  return axios.get(serviceUrl);
};

const getAdminReportCategoryData = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getAdminReportCategoryData',
    stub: config.useStubbedEndpoints,
  });
  return axios.get(serviceUrl);
};

const editAdminReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'editAdminReport',
    stub: config.useStubbedEndpoints,
    params: {
      reportCode: payload.reportCode,
    },
  });
  return axios.put(serviceUrl, payload.object);
};

const saveCategoryAdmin = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'saveCategoryAdmin',
    stub: config.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, payload.object);
};

const editCategoryAdmin = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'editCategoryAdmin',
    stub: config.useStubbedEndpoints,
    params: {
      categoryName: payload.categoryName,
    },
  });
  return axios.put(serviceUrl, payload.object);
};

const deleteCategoryAdmin = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteCategoryAdmin',
    stub: config.useStubbedEndpoints,
    params: {
      categoryName: payload.categoryName,
    },
  });
  return axios.delete(serviceUrl);
};

const uploadUserGuideAdmin = (payload) => {
  const formData = new window.FormData();

  formData.append('file', payload);

  const serviceUrl = constructServiceURL({
    endpoint: 'uploadUserGuideAdmin',
    stub: config.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const downloadUserGuideAdmin = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'downloadUserGuideAdmin',
    stub: config.useStubbedEndpoints,
  });
  return axios.get(serviceUrl, { responseType: 'blob' });
};

const putAdminImpcGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'putAdminImpcGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload.selectionName,
      direction: payload.direction,
      postalOperatorType: payload.postalOperatorType,
    },
  });
  return axios.put(serviceUrl, payload.selectedIMPCCodes);
};

const deleteAdminImpcGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteAdminImpcGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl);
};

const putAdminOperatorGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'putAdminOperatorGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload.selectionName,
      direction: payload.direction,
      postalOperatorType: payload.postalOperatorType,
    },
  });
  return axios.put(serviceUrl, payload.selectedIMPCCodes);
};

const deleteAdminOperatorGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteAdminOperatorGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl);
};

const putAdminUnlocodeGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'putAdminUnlocodeGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload.selectionName,
      direction: payload.direction,
      postalOperatorType: payload.postalOperatorType,
    },
  });
  return axios.put(serviceUrl, payload.selectedUnlocodes);
};

const deleteAdminUnlocodeGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteAdminUnlocodeGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl);
};

const putAdminProductGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'putAdminProductGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload.selectionName,
    },
  });
  return axios.put(serviceUrl, payload.selectedProducts);
};

const deleteAdminProductGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteAdminProductGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl);
};

const putAdminOperatorMailboxGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'putAdminOperatorMailboxGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload.selectionName,
      direction: payload.direction,
      postalOperatorType: payload.postalOperatorType,
    },
  });
  return axios.put(serviceUrl, payload.selectedEdiMailboxes);
};

const deleteAdminOperatorMailboxGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteAdminOperatorMailboxGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl);
};

const putAdminMrdImpcGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'putAdminMrdImpcGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload.selectionName,
    },
  });
  return axios.put(serviceUrl, payload.selectedIMPCCodes);
};

const deleteAdminMrdImpcGlobalPreset = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteAdminMrdImpcGlobalPreset',
    stub: config.useStubbedEndpoints,
    queryStringParams: {
      selectionName: payload,
    },
  });
  return axios.delete(serviceUrl);
};

export default {
  getAdminReportData,
  getAdminReportCategoryData,
  editAdminReport,
  saveCategoryAdmin,
  editCategoryAdmin,
  deleteCategoryAdmin,
  uploadUserGuideAdmin,
  downloadUserGuideAdmin,
  putAdminImpcGlobalPreset,
  deleteAdminImpcGlobalPreset,
  putAdminOperatorGlobalPreset,
  deleteAdminOperatorGlobalPreset,
  putAdminUnlocodeGlobalPreset,
  deleteAdminUnlocodeGlobalPreset,
  deleteAdminProductGlobalPreset,
  putAdminProductGlobalPreset,
  putAdminOperatorMailboxGlobalPreset,
  deleteAdminOperatorMailboxGlobalPreset,
  putAdminMrdImpcGlobalPreset,
  deleteAdminMrdImpcGlobalPreset,
};
